import { render, staticRenderFns } from "./EvolluArrow.vue?vue&type=template&id=744a3483&scoped=true"
import script from "./EvolluArrow.vue?vue&type=script&lang=js"
export * from "./EvolluArrow.vue?vue&type=script&lang=js"
import style0 from "./EvolluArrow.vue?vue&type=style&index=0&id=744a3483&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744a3483",
  null
  
)

export default component.exports